import type { useSingleton } from "@tippyjs/react";
import { PresentationButton } from "@/interface/HeaderBar/RightBar/Presentation/PresentationButton";

type PresentationProps = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    className?: string;
    disabledClass: string;
    isActive: boolean;
    activePresentationUID: string;
};

export const Presentation = (props: PresentationProps) => {
    return <PresentationButton {...props} />;
};
